module.exports = __webpack_public_path__ + "static/media/bike.dc31b430.svg";